@if (showTrialBanner) {
  <hyperkit-banner
    type="error"
    justify="center"
    [closable]="false"
    [showIcon]="false"
  >
    @if (daysRemaining > daysThreshold) {
      <hyperkit-typography
        variant="body"
        size="sm"
        color="primary"
        class="banner-text"
      >
        You're using HUNTER Community. Talk to an Intel 471 Expert today about
        Premium access.
      </hyperkit-typography>
    } @else {
      <hyperkit-typography
        variant="body"
        size="sm"
        color="primary"
        class="banner-text"
      >
        You have
        <hyperkit-typography
          variant="emphasized"
          size="sm"
          color="primary"
          display="inline"
          >{{ daysRemaining }}</hyperkit-typography
        >
        days left of HUNTER Community. Talk to an Intel 471 Expert today about
        extending your access.
      </hyperkit-typography>
    }
    <hyperkit-typography variant="emphasized" size="sm" color="primary"
      >Learn more.</hyperkit-typography
    >
  </hyperkit-banner>
}
@if (showVerityBanner) {
  <hyperkit-banner
    type="warning"
    justify="center"
    [closable]="false"
    actionText="Go to Verity"
    (action)="onVerityBannerAction()"
  >
    <hyperkit-typography
      variant="body"
      size="sm"
      color="primary"
      class="banner-text"
    >
      We're moving! Starting December 1, 2026, Hunter will only be available
      through Hunt Mode in Verity. Make the switch today!
    </hyperkit-typography>
    <hyperkit-typography
      variant="emphasized"
      size="sm"
      color="primary"
      class="verity-banner-link"
      (click)="onVerityBannerContactSupport()"
      >Don't have access yet? Contact support.</hyperkit-typography
    >
  </hyperkit-banner>
}
@if (!isiFrame) {
  <div class="wrapper">
    <div>
      <div class="row top">
        <div>
          <a
            [class.active-route]="isActive('/research')"
            routerLink="/research"
            class="logo desktop"
          >
            <img
              class="intel-logo"
              src="/assets/brand/intel-logo-{{ theme() }}.svg"
              alt="Intel logo"
            />
          </a>
          <a
            [class.active-route]="isActive('/research')"
            routerLink="/research"
            class="logo mobile"
            ><img
              src="/assets/brand/intel-bug-{{ theme() }}.svg"
              alt="Intel bug"
          /></a>
        </div>
        @if (loggedIn) {
          <div class="options">
            <div id="menu-outer">
              <div class="table">
                <ul id="horizontal-list">
                  <li>
                    <a
                      [class.active-route]="isActive('/research')"
                      routerLink="/research"
                      >Research</a
                    >
                  </li>
                  @if (huntModuleAccess) {
                    <li>
                      <a
                        [class.active-route]="isActive('/hunt')"
                        routerLink="/hunt/dashboard"
                        >Hunt</a
                      >
                    </li>
                  } @else {
                    <li>
                      <a routerLink="/hunt-gate">Hunt</a>
                    </li>
                  }
                </ul>
              </div>
            </div>
            <div class="account">
              <img
                src="/assets/brand/intel-bug-{{ theme() }}.svg"
                class="avatar"
                alt="User avatar"
              />
              <div class="panel">
                <div class="user">
                  <img
                    src="/assets/brand/intel-bug-{{ theme() }}.svg"
                    class="avatar"
                    alt="User avatar"
                  />
                  <div class="about">
                    <hyperkit-typography
                      variant="emphasized"
                      size="md"
                      align="left"
                      color="primary"
                      >{{ firstName }} {{ lastName }}</hyperkit-typography
                    >
                    <hyperkit-typography
                      variant="body"
                      size="md"
                      align="left"
                      color="secondary"
                      >{{ role | snakeToTitle }} &#x2022;
                      {{ status | companyStatus }}
                    </hyperkit-typography>
                  </div>
                </div>
                @if (status === statusTypes.TRIAL) {
                  <hyperkit-button
                    (click)="openPremiumDialog()"
                    size="small"
                    text="Upgrade your plan"
                    color="secondary"
                    [customImage]="'/assets/img/icons/cyborg-premium.png'"
                    [variant]="'standard'"
                  ></hyperkit-button>
                }
                <ul>
                  <li>
                    <a routerLink="/settings" title="Settings">Settings</a>
                  </li>
                  <li>
                    <a routerLink="/customer-support" title="Contact">
                      Contact
                    </a>
                  </li>
                </ul>
                <hyperkit-message
                  type="info"
                  class="new"
                  routerLink="/releases"
                  [text]="'Check out what\'s new in Version ' + latest"
                ></hyperkit-message>
                <a routerLink="" class="logout" (click)="onLogOut()"
                  >Logout <i class="k-icon k-font-icon k-i-logout"></i
                ></a>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
